import { Link } from "gatsby";
import { GatsbyImage, IGatsbyImageData } from "gatsby-plugin-image";
import React, { ReactNode } from "react";

import {
  detailSmall,
  heading100,
  heading150,
  heading300,
  paragraphTextMedium,
  paragraphTextSmall,
} from "../../../stitches/combinedStyles";
import { styled } from "../../../stitches/stitches.config";
import Button, { ButtonProps } from "../Button/Button";

interface TextWithTitleAndButtonProps {
  title: string;
  children: ReactNode;
  button?: {
    text: string;
    path: string;
    tier?: ButtonProps["tier"];
    padding?: boolean;
    download?: boolean;
  };
  className?: string;
}

const TextWithTitleAndButton = ({
  title,
  children,
  button,
  className,
}: TextWithTitleAndButtonProps) => {
  const childrenArr = React.Children.toArray(children);

  return (
    <TextContent className={className}>
      <Title>{title}</Title>

      {childrenArr.map((text, i) => (
        <Byline key={i}>{text}</Byline>
      ))}
      {button && (
        <ButtonsContainer>
          <Link
            to={button.path}
              onClick={(event) => {
                if(button.download){
                event.preventDefault();
                const a = document.createElement('a')
                a.href = button.path
                a.download = button.path.split('/').pop() as string;
                document.body.appendChild(a)
                a.click()
                document.body.removeChild(a)
                }  
              }}
              >
            <Button
              size="medium"
              tier={button.tier || "secondary"}
              arrow
              noPadding={!button.padding}
            >
              {button.text}
            </Button>
          </Link>
        </ButtonsContainer>
      )}
    </TextContent>
  );
};

export default TextWithTitleAndButton;

const TextContent = styled("div", {
  position: "relative",
  width: "100%",
  padding: "0px 32px",
"@md": {
  padding: 32,
}
});

const Title = styled("h4", {
  ...heading150,
  marginBottom: 24,
  "@md": {
    fontSize:30,
  },
  "@lg": {
    ...heading300,
    letterSpacing: -0.76,
    marginTop: 0,
  },
});

const Byline = styled("p", {
  ...detailSmall,
  letterSpacing: "normal",

  "@sm": {
    ...paragraphTextSmall,
    letterSpacing: "normal",
  },

  "@lg": {
    ...paragraphTextMedium,
    letterSpacing: "normal",
  },
});

const ButtonsContainer = styled("div", {
  alignItems: "center",
  display: "flex",
});